import React from "react";
import t, {changeLanguage} from "../../../components/I18N/TranslateHelpers";
import {GetCurrentLocale, pathname} from "../../../components/Utils";
import ResetPasswordFormContainer from "./ResetPasswordFormContainer";
import AskNewPasswordForm from "./AskNewPasswordForm"


const AskResetPasswordPage = () => {
  const locale = GetCurrentLocale();
  changeLanguage(locale)

  let isResetPasswordPage = false
  let isAskNewPasswordPage= false
  if(pathname === "/" + locale + t('url_reset_mdp')){
    isResetPasswordPage = true
  }
  if(pathname === "/" + locale + t('url_forgot_mdp')){
    isAskNewPasswordPage = true
  }

  return (
  <div className="container py-5">
    <div className="login row align-items-center">
      <div className="col-lg-6">
        <div className="row justify-content-center">
          <div className="col-lg-8 card nobackground noborder noboxshadow">
            <div className="card-body">
              {
                isResetPasswordPage ?
                  <ResetPasswordFormContainer/>
                  :
                  isAskNewPasswordPage ?
                    <AskNewPasswordForm/>
                    : null
              }
              {
                !isResetPasswordPage ?
                  <>
                    <p className="text-divider my-4">{ t('password_found')}</p>
                    <a href={ "/" + locale + t('url_login')} className="btn w-100 btn-light">{ t('login')}</a>
                  </>
                  : null
              }
            </div>
          </div>
        </div>
      </div>
      <div className="col-lg-6">
        {
          isResetPasswordPage ?
            <>
              <h1 className="display-4 text-white">{t('change_password')}</h1>
              <p className="lead py-5 mb-0 text-white">
                {t('enter_new_password')}
              </p>
            </>
            :
            isAskNewPasswordPage ?
              <>
                <h1 className="display-4 text-white">{t('forgot_password')}</h1>
                <p className="lead py-5 mb-0 text-white">
                  {t('description_new_password')}
                </p>
              </>
              : null
        }
      </div>
    </div>
  </div>
  );
}

export default AskResetPasswordPage;
